import { makeStyles } from "@material-ui/styles";


export const useStyle = makeStyles(() => ({
  ClaimActionButtons:{
    width: "50%",
    margin: "30px auto"
  }

}));